import { routes } from "@/routes";
import { cloneElement, useEffect, useState } from "react";
import { FiChevronUp } from "react-icons/fi";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../Logo";
import classes from "./SideBar.module.css";
import { signOutRequest } from "@/store/auth/authSlice";
import { useDispatch } from "react-redux";
const SideBar = ({ isCollapsed, isMobile }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = () => {
    dispatch(signOutRequest());
    navigate("/login");
  };
  return (
    <div className={classes?.mainContainer}>
      <div
        className={[classes.itemsContainer, isMobile && classes.isMobile].join(
          " "
        )}
      >
        {/* Logo for mobile drawer */}
        {isMobile && (
          <div className={classes.mobileLogoContainer}>
            <Logo variant="logo" customClass={classes.mobileLogo} />
          </div>
        )}

        <div
          className={[
            classes.items,
            isCollapsed && classes.itemsCollapsed,
          ].join(" ")}
        >
          {routes?.map((item, index) => {
            if (!item?.showInSidebar) return null;
            return (
              <RenderItem
                icon={item?.icon}
                title={item?.title}
                path={item?.path}
                subMenu={item?.subMenu}
                isCollapsed={isCollapsed}
                key={index}
              />
            );
          })}
        </div>

        <div className={classes.sidebarLinks}>
          <span className={classes?.listItemContainer} onClick={handleLogout}>
            <RiLogoutCircleRLine size={20} color="var(--icon-gray)" />
            <span>Logout</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default SideBar;

const RenderItem = ({ icon, title, subMenu = [], path, isCollapsed }) => {
  const pathname = useLocation().pathname;
  const active = pathname === path ? true : false;
  const [subnav, setSubnav] = useState(false);
  const subActive = subMenu.find((item) => item?.path == pathname);
  const navigate = useNavigate();
  const showSubnav = () => setSubnav(!subnav);
  useEffect(() => {
    const allPaths = subMenu.map((item) => item?.path);
    if (allPaths.includes(pathname)) {
      setSubnav(true);
    }
  }, []);

  return (
    <>
      <span
        className={[
          classes?.listItemContainer,
          (active || subnav) && classes?.active,
          subActive && classes?.subActive,
          subnav &&
            [isCollapsed ? classes?.isCollapsedSubnav : classes.subnav].join(
              " "
            ),
          isCollapsed ? classes.isCollapsed : "",
        ].join(" ")}
        data-title={title}
        // href={subMenu?.length > 0 ? "#" : path}
        onClick={() => {
          if (subMenu?.length > 0) {
            showSubnav(!subnav);
          } else {
            if (path != "#") {
              navigate(path);
            }
          }
        }}
      >
        {icon &&
          cloneElement(icon, {
            color: "var(--black-color-v1)",
            className: classes.icon,
          })}
        {!isCollapsed && <span>{title}</span>}
        {subMenu?.length > 0 && !isCollapsed && (
          <FiChevronUp size={20} className={classes?.dropDownIcon} />
        )}
      </span>

      {subnav && (
        <div
          className={[
            classes?.subMenu,
            isCollapsed ? classes.submenuIsCollapsed : "",
          ].join(" ")}
        >
          {subMenu.map((item, index) => {
            return (
              <span
                onClick={() => {
                  if (item?.path != "#") {
                    navigate(item?.path);
                  }
                }}
                className={[
                  classes?.innerItemContainer,
                  isCollapsed
                    ? classes.isCollapsed
                    : classes?.notCollapsedInnercontainer,
                  subActive?.path === item?.path && classes?.innerItemSubActive,
                ].join(" ")}
                data-title={item?.title}
                key={index}
                to={item?.path}
              >
                {item?.icon &&
                  isCollapsed &&
                  cloneElement(item?.icon, {
                    size: 17,
                    // color: "var(--black-color-v1)",
                    className: classes.innerIcon,
                  })}
                {!isCollapsed && <span>{item?.title}</span>}
              </span>
            );
          })}
        </div>
      )}
    </>
  );
};
